import { combineReducers } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';
import {
  CommonReducer,
  globalpayReducer,
  ListBillsReducer,
  ListCompaniesReducer,
  ListCustomersReducer,
  ListInvoicesReducer,
  ListVendorsReducer,
  onBoardAUS,
  OnBoardReducer,
  onBoardUS,
  settlementsReducer,
  UserReducer,
} from './store';

import * as subscriptions from 'src/views/subscription/v2/lib/store';

const rootReducer = combineReducers({
  form: formReducer,

  //--- Customers
  listCustomers: ListCustomersReducer,

  //--- Vendors
  listVendors: ListVendorsReducer,

  //--- Bills
  listBills: ListBillsReducer,

  //--- Invoices
  listInvoices: ListInvoicesReducer,

  //--- Company
  listCompanies: ListCompaniesReducer,

  //--- OnBoarding
  onBoard: OnBoardReducer,
  onBoardUS: onBoardUS.OnBoardUSReducer,
  onBoardAUS: onBoardAUS.OnBoardAUSReducer,

  //--- userReducer
  user: UserReducer,

  //--- commonReducer
  common: CommonReducer,

  //--- settlementsReducer
  settlements: settlementsReducer,

  //--- globalpay
  globalpay: globalpayReducer,

  //--- subscription
  ...subscriptions
});

export default rootReducer;
